(function() { window.GUID_87e6ae87_dc89_4f0a_aba9_0d548863fb8c = { getGuid: function() { return "87e6ae87-dc89-4f0a-aba9-0d548863fb8c"; } }; })();
var CS;
(function (CS) {
    class Radio {
        constructor(inputBox) {
            this.SetStyle = function () {
            };
            this.SetEvents = function () {
                var me = this;
                $(this.Radio).off('change');
                $(this.Radio).on('change', function () {
                    me.Radio.trigger("CSChange", me);
                });
            };
            this.Radio = $(inputBox);
            //Protection pour le nouveau helper
            if (this.Radio.hasClass('IHasChanged')) {
                return;
            }
            this.RadioId = this.Radio[0].id;
            this.SetEvents();
        }
    }
    CS.Radio = Radio;
})(CS || (CS = {}));
/*
(function ($) {
    $.fn.CSRadio = function () {
        this.each(function () {
            var radio = new CS.Radio($(this));
            //Donne access au checkbox de n'importe quels scripts.
            if (radio.RadioId != "")
            {
                eval('document.' + radio.RadioId + '=radio;');
            }
        });
    };
})(jQuery);


var CS = CS || {};

CS.Radio = function (inputBox) {

    this.Radio = $(inputBox);
    this.RadioId = this.Radio[0].id;
    this.SetEvents();
};

CS.Radio.prototype = function () {

    var SetStyle = function () {

    },
    SetEvents = function () {
        var me = this;
        
        $(this.Radio).off('change');
        $(this.Radio).on('change', function () {

            me.Radio.trigger("CSChange", me);

        });
    };
    return {
        SetStyle: SetStyle,
        SetEvents: SetEvents
    };

}();
*/ 

//# sourceMappingURL=cs.radio.js.map
